import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBack from '../../assets/icon/ArrowBack';
import WeatherDetails from './Weather';
import CommentsSection from './CommentSection';
import { LABELS } from '../../constants/labels';
import calenderApi from '../../api/calenderApi';
import { Detail, Value } from 'react-calendar/dist/cjs/shared/types';
import useLocationStore from '../../store/locatonStore';
import { BallTriangle } from 'react-loader-spinner';
import useBgColorStore from '../../store/bgColor';
import { toast } from 'react-toastify';
import CalenderScreen from './CalenderScreen';
import { showOrReplaceToast } from '../../utils/utility';
import { CUSTOM_TOAST_ID } from '../../constants/constant';

const Calendar = () => {
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [comments, setComments] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const selectedLocation = useLocationStore((state) => state.selectedLocation);

  const handleDateChange = (value: Value) => {
    let date =
      value instanceof Date ? value : Array.isArray(value) ? value[0] : null;

    if (date) {
      setSelectedDate(date);
      fetchCalendarDetails(date);

      const firstDate = new Date(
        date?.getFullYear(),
        date?.getMonth(),
        1,
      ).toLocaleDateString('en-CA');
      const lastDate = new Date(
        date?.getFullYear(),
        date?.getMonth() + 1,
        0,
      ).toLocaleDateString('en-CA');
    } else {
      setSelectedDate(null);
    }
  };

  const fetchCalendarDetails = async (date: Date) => {
    if (!date) return;
    setLoading(true);
    try {
      const ownerId = selectedLocation?.OwnerId;
      const formattedDate = date?.toLocaleDateString('en-CA');
      const response = await calenderApi.getCalendarDetails(
        ownerId,
        formattedDate,
      );
      const comments = response?.data?.general_comments;

      const commentsArray = comments.split('\n');
      setComments(commentsArray);
    } catch (error) {
      showOrReplaceToast(
        CUSTOM_TOAST_ID.calender,
        'Error fetching calendar details:',
        'error',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {loading == true ? (
        <div className="flex justify-center items-center h-screen">
          <BallTriangle
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="loading"
            wrapperStyle={{}}
            visible={true}
          />
        </div>
      ) : (
        <>
          <div className="flex flex-col items-center w-full h-full sm:p-4 bg-backgroundColor-white">
            <header className="w-full flex items-center justify-between p-4">
              <button
                className="text-textColor flex-shrink-0"
                onClick={() => navigate(-1)}
              >
                <ArrowBack />
              </button>
              <h1 className="text-lg font-medium flex-grow text-center text-textColor">
                {LABELS?.CALENDAR}
              </h1>
            </header>
            <div className="w-full text-text-primary">
              <CalenderScreen
                setComments={setComments}
                setSelectedDate={setSelectedDate}
              />
            </div>
            <div className="sm:hidden">
              <WeatherDetails />
            </div>
            

            <div className="w-full hidden sm:flex gap-16 mt-8">
              <div className="w-2/5 box-border">
                <WeatherDetails />
              </div>
              
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Calendar;
